// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"0d4e512e","239":"943c0bec","345":"95a6074d","389":"919152d0","453":"a1e914d4","613":"2b5a5ed1","732":"91ecb613","848":"d8ead87f","977":"bbd06785"}[chunkId] + ".chunk.js";
};